import styled from "styled-components";

export const Divider = styled.div`
    display: inline-block;
    height: .025rem;
    width: 100%;
`